export const slugGenerator = (str) => {
  return String(str)?.replace(/[\u200B-\u200D\uFEFF]/g, '')?.replace(/-/g, ' ')?.replace(/\s+/g, "-") || ""
};
